import { rootApi } from "../../api/rootApi";

export const cavinApi = rootApi.injectEndpoints({
    endpoints: (builder) => ({
        fetchDailyData: builder.mutation({
            query: (params) => {
                return {
                    method: "POST",
                    url: `/tenant/cavin/panel/daily`,
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + params.token,
                        slug: params.tenant_id,
                    },
                    body: params.body
                };
            },
        }),

        fetchMonthlyData: builder.mutation({
            query: (params) => {
                return {
                    method: "POST",
                    url: `/tenant/cavin/panel/month`,
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + params.token,
                        slug: params.tenant_id,
                    },
                    body: params.body
                };
            },
        }),
    }),
});

export const {
    useFetchDailyDataMutation,
    useFetchMonthlyDataMutation
} = cavinApi;
